/**
 请组合使用eg:
 <customizable-view config="customizedConfig">
    <query-form config="customizedConfig.queryConfig"></query-form>
    <table-label-filter config="customizedConfig.tableFieldConfig"></table-label-filter>
 </customizable-view>
 */

import angular from 'angular'
import template from './errorPage.html'

const errorPageModule = angular
    .module('app.errorPage', [])

errorPageModule.directive('errorPage', () => ({
    scope: {
        msg: '@',
        showWhile: '<',
    },
    replace: true,
    template,
}))
export default errorPageModule.name



// WEBPACK FOOTER //
// ./src/components/errorPage/index.js